import { Feature, Product, Role } from '../enums';

enum NavTypes {
  core = 'core',
  side = 'side',
}

export enum NavItemType {
  invites = 'invites',
  quickActions = 'quickActions',
  standard = 'standard',
}

export interface NavItem {
  type: NavItemType;
  link?: string;
  icon?: string;
  imageType?: string;
  title?: string;
  displayOrder?: { [product in Product]?: { [navType in NavTypes]?: number } };
  external?: boolean;
  feature?: Feature; // TODO: need to be an array?
  role?: Role; // TODO: need to be an array?
}
